import script from "./SystemUser.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemUser.vue?vue&type=script&setup=true&lang=js"

import "./SystemUser.vue?vue&type=style&index=0&id=43b55730&lang=css"

const __exports__ = script;

export default __exports__